import $ from 'jquery';

export default class {
    constructor(social = true) {
        this.subscriptions = [];

        // check if window.ga is already available
        if (process.env.NODE_ENV !== 'production') {
            if (window.ga === undefined) {
                console.warn('`window.ga` is not defined, ensure GoogleAnalytics ' +
                             'is embeded BEFORE using this helper!');
            }
        }

        // init social listening if wanted
        if (social) { this.initSocial(); }
    }

    pageview(page, title) {
        var pageviewConfig = {
            hitType:   'pageview',
            useBeacon: true,
            page:      page || (window.location.pathname + window.location.search)
        };

        if (title !== undefined && title) {
            pageviewConfig.title = title;
        }

        window.ga('send', pageviewConfig);

        this._callSubscriber(
            'pageview',
            pageviewConfig.page,
            pageviewConfig.title
        );
    }

    event(category, action, label, value) {
        var eventConfig = {
            hitType:   'event',
            useBeacon: true
        };

        if (category !== undefined && category) {
            eventConfig.eventCategory = category;
        }
        if (action !== undefined && action) {
            eventConfig.eventAction = action;
        }
        if (label !== undefined && label) {
            eventConfig.eventLabel = label;
        }

        if (value !== undefined && value) {
            if (typeof value === 'number' && isFinite(value) && value % 1 === 0) {
                eventConfig.eventValue = value;
            } else {
                throw 'GA: the given value "' + value + '" must be an integer or a float';
            }
        }

        window.ga('send', eventConfig);

        this._callSubscriber(
            'event',
            eventConfig.eventCategory,
            eventConfig.eventAction,
            eventConfig.eventLabel,
            eventConfig.eventValue
        );
    }

    social(network, action, target) {
        var socialConfig = {
            hitType:   'social',
            useBeacon: true
        };

        if (network !== undefined && network) {
            socialConfig.socialNetwork = network;
        }
        if (action !== undefined && action) {
            socialConfig.socialAction = action;
        }
        if (target !== undefined && target) {
            socialConfig.socialTarget = target;
        }

        window.ga('send', socialConfig);

        this._callSubscriber(
            'social',
            socialConfig.socialNetwork,
            socialConfig.socialAction,
            socialConfig.socialTarget
        );
    }

    subscribe(action, callback) {
        if (this.subscriptions[action] === undefined) {
            this.subscriptions[action] = [];
        }

        this.subscriptions[action].push(callback);
    }

    _callSubscriber() {
        var args = [].splice.call(arguments, 0),
            action = args.splice(0, 1);

        for (let s in this.subscriptions[action]) {
            if (this.subscriptions[action].hasOwnProperty(s)) {
                this.subscriptions[action][s].apply(null, args);
            }
        }
    }

    initSocial() {
        var _self = this,
            oldCallback;

        // ***************************** Facebook ****************************
        // if FB is defined init listener
        if (window.FB !== undefined) {
            _self._facebookInitSocialTracking();
        } else {
            // if not init it in the facebook async callback
            oldCallback = window.fbAsyncInit;

            window.fbAsyncInit = function() {
                if (oldCallback !== undefined) {
                    oldCallback();
                }

                _self._facebookInitSocialTracking();
            };
        }

        // ***************************** Twitter *****************************
        if (window.twttr !== undefined) {
            window.twttr.ready(function(twttr) {
                twttr.events.bind('click',    _self._twitterClickEvent.bind(_self));
                twttr.events.bind('tweet',    _self._twitterTweetIntent.bind(_self));
                twttr.events.bind('retweet',  _self._twitterRetweetIntent.bind(_self));
                twttr.events.bind('favorite', _self._twitterFavIntent.bind(_self));
                twttr.events.bind('follow',   _self._twitterFollowIntent.bind(_self));
            });
        }

        // *************************** Pinterest *****************************
        // pin it
        $('body').on('click', 'a[data-pin-log="button_pinit_bookmarklet"]', function() {
            _self.social('pinterest', 'pin', ($(this).parent().data('href') || $(this).data('pin-href')));
        });

        // follow
        $('body').on('click', 'a[data-pin-log="button_follow"]', function() {
            _self.social('pinterest', 'follow', $(this).attr('href'));
        });

        // embed
        $('body').on('click', 'a[data-pin-log="embed_pin"]', function() {
            _self.social('pinterest', 'embed', $(this).parent().attr('href'));
        });
    }

    _facebookInitSocialTracking() {
        var _self = this;

        // like
        window.FB.Event.subscribe('edge.create', function(targetUrl) {
            _self.social('facebook', 'like', targetUrl);
        });

        // unlike
        window.FB.Event.subscribe('edge.remove', function(targetUrl) {
            _self.social('facebook', 'unlike', targetUrl);
        });

        // send (messenger)
        window.FB.Event.subscribe('message.send', function(targetUrl) {
            _self.social('facebook', 'send', targetUrl);
        });

        // comment
        window.FB.Event.subscribe('comment.create', function(widget) {
            _self.social('facebook', 'comment', widget.href);
        });

        // uncomment
        window.FB.Event.subscribe('comment.remove', function(widget) {
            _self.social('facebook', 'uncomment', widget.href);
        });
    }

    _twitterClickEvent(intentEvent) {
        if (!intentEvent) {
            return;
        }

        this.social(
            'twitter',
            intentEvent.type,
            intentEvent.region
        );
    }

    _twitterTweetIntent(intentEvent) {
        if (!intentEvent) {
            return;
        }

        this.social(
            'twitter',
            intentEvent.type,
            'tweet'
        );
    }

    _twitterFavIntent(intentEvent) {
        this.twitterTweetIntent(intentEvent);
    }

    _twitterRetweetIntent(intentEvent) {
        if (!intentEvent) {
            return;
        }

        this.social(
            'twitter',
            intentEvent.type,
            intentEvent.data.source_tweet_id
        );
    }

    _twitterFollowIntent(intentEvent) {
        if (!intentEvent) {
            return;
        }

        this.social(
            'twitter',
            intentEvent.type,
            (intentEvent.data.user_id + ' (' + intentEvent.data.screen_name + ')')
        );
    }
}



// WEBPACK FOOTER //
// ./~/@spinnwerk/google-analytics/google-analytics.js